import React, { FunctionComponent } from "react";
import { connect } from "react-redux";
import { themeColors } from "../../Components/theme";
import "../../theme-vars.css";

type props = { history: any; user: any; theme: any };

const AboutUs: FunctionComponent<props> = ({ history, user, theme }) => {
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  return (
    <div
      className="container-fluid p-4 d-flex flex-column gap-4"
      style={{
        minHeight: "100vh",
        height: "fit-content",
        ...containerStyles,
        marginTop: "3.5%",
      }}
    >
      {/* Top heading */}
      <div className="d-flex justify-content-between">
        <h5
          className="w-100 text-center"
          style={{
            marginBottom: "0rem",
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-large)",
          }}
        >
          About Us
        </h5>
      </div>

      {/* About Us Content */}
      <div
        className="d-flex flex-column gap-2"
        style={{
          ...containerStyles,
          height: "70vh",
          overflowY: "auto",
          borderRadius: "8px",
          padding: "0 1rem 1rem 1rem",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          The core value behind the Foundation of <b>Leads Rubix Solution</b> is
          to provide Technologically Innovative Solutions. We are an IT company
          having expertise in providing technologically innovative solutions for
          your business operations automation, and helping organizations address
          the evolving business needs and challenges in a highly competitive
          industry through digital transformations and services tailored to your
          specific business requirements so you can maximize utilization of all
          your resources, without increasing your budget and get the best out of
          it to increase your business and ultimately the profit with ease.
        </span>
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          We can automate complicated and time-consuming processes of business
          with the help of our automation tools, and by our real-time Reporting
          Dashboard, you can track and improve your business to make your life
          smooth.
        </span>
        <h6
          style={{
            marginTop: "10px",
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-medium)",
          }}
        >
          About Leads Rubix Solution
        </h6>
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          We are inspired by real problems, and to drive real results we are
          developed as Leads Rubix Solution – a professional business management
          and operations automation solution provider with the help of the latest
          technology. Leads Rubix Solution is a Noida, Uttar Pradesh-based CRM Software
          and ERP Software Development Company delivering successfully CRM and ERP
          Software since the year 2017. Our expert teams develop effective software
          solutions that help clients increase their overall business productivity
          through correct business management software to resolve their problems.
        </span>
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          We develop simple, yet effective solutions and aim to provide stable and
          high-quality products at optimal rates, empowering our clients to perform
          their best in their segment and become most profitable with ease. Leads
          Rubix Solution evolved to offer a range of products and services to very
          diverse industry segments. Our Team empowers organizations globally to
          own and grow their sales drive growth. We provide CRM and Customized ERP
          Software and support to help organizations reach their true growth
          potential.
        </span>
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          Leads Rubix Solution also has a unique structure of functioning which
          strives more for quality and also timely communication with the client
          for hassle-free performance. We provide a team of skilled manpower as per
          the client and project requirements, which is 100% dedicated to the
          project. To ensure customer satisfaction by developing quality work,
          timely delivery & excellent support so our clients can generate the
          highest productivity from their business. And this is the secret behind
          the 100% satisfaction of all our clients with our products and services.
        </span>
        <h6
          style={{
            marginTop: "10px",
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-medium)",
          }}
        >
          Our Vision
        </h6>
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          As a professional software provider company, Leads Rubix Solution has the
          vision to develop and constantly improve ourselves to grow as a crucial
          IT service provider to become a foremost performer, providing quality
          software solutions in this competitive global marketplace. Our core
          vision is to provide the management automation software solution to our
          customers to grow their businesses with the help of technology so they
          can more focus on the quality task and set the automation on the
          recurring task so they can get the best out of their resources like an
          employee, machinery, etc. and increase their profit with ease.
        </span>
        <span
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          Fortunately, we have been able to bring together talented professionals,
          and through their collective skills and experiences, we have truly
          converted our vision into reality, and we are still striving every day
          to be the best version of ourselves to accelerate our growth toward its
          highest peak.
        </span>
        <h6
          style={{
            marginTop: "10px",
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-medium)",
          }}
        >
          Our Services
        </h6>
        <ul
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
          }}
        >
          <li>Sales CRM Software</li>
          <li>Realestate CRM Software</li>
          <li>ERP Software</li>
          <li>Inventory Management Software</li>
          <li>Helpdesk CRM Software</li>
          <li>Project & Task Management Software</li>
          <li>Custom Software Development</li>
          <li>Property Management Software</li>
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
  };
};

export default connect(mapStateToProps)(AboutUs);